<template>
  <div>
    <div class="tabsNotes">
      <div class="dates-wrap">
        <h5 class="dates">November, 2024</h5>
        <div class="create-note"></div>
      </div>
      <div class="accordion-wrap">
        <div id="accordion">
          <div class="card mb-3">
            <div class="card-header" id="headingFive">
              <h5 class="mb-0">
                <div class="accordion-header">
                  <button
                    class="btn btn-link collapsed"
                    data-toggle="collapse"
                    data-target="#collapseFive"
                    aria-expanded="true"
                    aria-controls="collapseFive"
                  >
                    <div class="container-fluid accordion-button-content">
                      <div class="accordion-heading-wrap">
                        <div class="accordion-arrow-wrap">
                          <h5 class="accordion-heading">
                            <i class="fas fa-chevron-right accordion-arrow"></i>
                            How does writing influence your personal brand?
                          </h5>
                          <h5 class="accordion-heading1">Meeting Purpose</h5>
                          <h5 class="accordion-para">
                            Demonstrate LinenTech software capabilities to
                            Joseph Kendziuk for potential implementation in his
                            linen business.
                          </h5>
                        </div>
                        <div class="accordion-time-wrap">
                          <div class="accordion-time">
                            <h5 class="time-span">19 September, 2024</h5>
                            <h5 class="time-span">04:23 PM GMT</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </button>
                  <button
                    class="accordion-menu"
                    @click="toggleMenu('headingFive')"
                    :class="{
                      activeMenu: activeMenuId === 'headingFive',
                    }"
                  >
                    <i class="fas fa-ellipsis-h"></i>
                    <div class="accordionDropdown">
                      <div class="accordionDropdownWrapper">
                        <button class="editDeleteBtn">
                          <img :src="editIcon" alt="" /> Edit
                        </button>
                        <button class="editDeleteBtn">
                          <img :src="deleteIcon" alt="" /> Delete
                        </button>
                      </div>
                    </div>
                  </button>
                </div>
                <div
                  id="collapseFive"
                  class="collapse"
                  aria-labelledby="headingFive"
                  data-parent="#accordion"
                >
                  <div class="card-body">
                    <h5 class="card-heading">Meeting Purpose</h5>
                    <p class="card-para">
                      Demonstrate LinenTech software capabilities to Joseph
                      Kendziuk for potential implementation in his linen
                      business.
                    </p>
                    <h5 class="card-heading">Key Takeaways</h5>
                    <ul class="card-list">
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                    </ul>
                    <h5 class="card-heading">Topics</h5>
                    <h5 class="card-heading">Current Business Operations</h5>
                    <ul class="card-list">
                      <li>95% hospitality clients, 5% takeaway/box orders</li>
                    </ul>
                  </div>
                  <div class="notesButtonWrapper">
                    <button class="addEditNotes addButtonNotes">
                      <i class="fas fa-plus"></i>
                    </button>
                    <button class="addEditNotes editButtonNotes">
                      <img :src="pencilEdit" alt="" />
                    </button>
                  </div>
                </div>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabsNotes">
      <div class="dates-wrap">
        <h5 class="dates">December, 2024</h5>
        <div class="create-note"></div>
      </div>
      <div class="accordion-wrap">
        <div id="accordion">
          <div class="card mb-3">
            <div class="card-header" id="headingSix">
              <h5 class="mb-0">
                <div class="accordion-header">
                  <button
                    class="btn btn-link collapsed"
                    data-toggle="collapse"
                    data-target="#collapseSix"
                    aria-expanded="true"
                    aria-controls="collapseSix"
                  >
                    <div class="container-fluid accordion-button-content">
                      <div class="accordion-heading-wrap">
                        <div class="accordion-arrow-wrap">
                          <h5 class="accordion-heading">
                            <i class="fas fa-chevron-right accordion-arrow"></i>
                            How does writing influence your personal brand?
                          </h5>
                          <h5 class="accordion-heading1">Meeting Purpose</h5>
                          <h5 class="accordion-para">
                            Demonstrate LinenTech software capabilities to
                            Joseph Kendziuk for potential implementation in his
                            linen business.
                          </h5>
                        </div>
                        <div class="accordion-time-wrap">
                          <div class="accordion-time">
                            <h5 class="time-span">19 September, 2024</h5>
                            <h5 class="time-span">04:23 PM GMT</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </button>
                  <button
                    class="accordion-menu"
                    @click="toggleMenu('headingSix')"
                    :class="{
                      activeMenu: activeMenuId === 'headingSix',
                    }"
                  >
                    <i class="fas fa-ellipsis-h"></i>
                    <div class="accordionDropdown">
                      <div class="accordionDropdownWrapper">
                        <button class="editDeleteBtn">
                          <img :src="editIcon" alt="" /> Edit
                        </button>
                        <button class="editDeleteBtn">
                          <img :src="deleteIcon" alt="" /> Delete
                        </button>
                      </div>
                    </div>
                  </button>
                </div>
                <div
                  id="collapseSix"
                  class="collapse"
                  aria-labelledby="headingSix"
                  data-parent="#accordion"
                >
                  <div class="card-body">
                    <h5 class="card-heading">Meeting Purpose</h5>
                    <p class="card-para">
                      Demonstrate LinenTech software capabilities to Joseph
                      Kendziuk for potential implementation in his linen
                      business.
                    </p>
                    <h5 class="card-heading">Key Takeaways</h5>
                    <ul class="card-list">
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                      <li>
                        Joseph's business: ~95% hospitality clients, 2 routes,
                        ~650 customers serviced bi-weekly
                      </li>
                    </ul>
                    <h5 class="card-heading">Topics</h5>
                    <h5 class="card-heading">Current Business Operations</h5>
                    <ul class="card-list">
                      <li>95% hospitality clients, 5% takeaway/box orders</li>
                    </ul>
                  </div>
                  <div class="notesButtonWrapper">
                    <button class="addEditNotes addButtonNotes">
                      <i class="fas fa-plus"></i>
                    </button>
                    <button class="addEditNotes editButtonNotes">
                      <img :src="pencilEdit" alt="" />
                    </button>
                  </div>
                </div>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pencilEdit from "@/assets/images/pencil-edit.svg";
import editIcon from "@/assets/images/edit2.svg";
import deleteIcon from "@/assets/images/delete.svg";
export default {
  name: "EmailTab",
  props: {
  },
  data() {
    return {
      activeMenuId: null,
      deleteIcon: deleteIcon,
      editIcon: editIcon,
      pencilEdit: pencilEdit,
    };
  },
  methods:{
    toggleMenu(menuId) {
    this.activeMenuId = this.activeMenuId === menuId ? null : menuId;
    },
  }
};
</script>
